/* eslint-disable */
import moment from "moment";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
//#end Global Imports

//Local Imports
import Button from "../../../../components/ui/Button";
import TextField from "../../../../components/ui/TextField";
import { getRequestTime, handleLogin, verifyReCaptcha } from "../../../../services/auth";
import { getErrorMessage, regexForEmailAddress, regexForPassword } from "../../../../utils";
import ErrorField from "../../../../components/ui/ErrorField";
import { Mixpanel } from "../../../../constants/mixpanel";
import AuthBgLayout from "../../../../components/layout/AuthBgLayout";
//End Local Imports

interface IProps {
    isUserRegistered: string;
    signInError: string;
    isIncorrectPassword: boolean;
    setIsForgotPassword: React.Dispatch<React.SetStateAction<boolean>>;
    setInorrectPassword: React.Dispatch<React.SetStateAction<boolean>>;
    setIsUserRegistered: React.Dispatch<React.SetStateAction<string>>;
    saveUserData: React.Dispatch<React.SetStateAction<{ email: string; password: string }>>;
    isDisabled: boolean;
    loading: boolean;
    setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
    handleClickedLogin: (data: any) => void;
  }

type FormInputs = {
    email: string;
    password: string;
};

export const Loginform: React.FC<IProps> = ({
    isUserRegistered,
    isIncorrectPassword,
    saveUserData,
    setIsForgotPassword,
    setInorrectPassword,
    setIsUserRegistered,
    isDisabled,
    setIsDisabled,
    handleClickedLogin,
    loading,
    signInError,
}) => {
    const navigate = useNavigate();

    const {
        formState: { errors },
        handleSubmit,
        control,
        setError,
    } = useForm<FormInputs>();
    const recaptchaRef = React.useRef<any | null>(null);
    const onSubmit = (data: any) => {
        handleClickedLogin(data);
    };

    const captchaValidate = (token: string | null) => {
        if (token) {
            verifyReCaptcha({ response: token })
                .then((response) => {
                    if (response.data) {
                        setIsDisabled(false);
                    } else {
                        setIsDisabled(true);
                    }
                })
                .catch(() => {
                    setIsDisabled(true);
                });
        }
    };

    useEffect(() => {
        setInorrectPassword(errors.password?.type === "pattern");
    }, [errors.password]);

    return (
        <>
          <div className="flex flex-col items-center justify-center w-full mt-[129px]">
            <img src="/images/svg/moneyhop-logo.svg" alt="moneyhop-logo" className="mb-8" />
            <div className="md:flex flex-col items-center pb-[54px] hidden">
              <div className="text-base font-normal text-black font-ssp">
                Cross-border payments made
              </div>
              <div className="text-[22px] font-semibold text-black font-ssp">
                Smarter, Faster, Better.
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center w-full">
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col items-center"
              autoComplete="off"
            >
              <div className="pb-[34px] sm:pb-[38px] w-screen sm:w-[300px] px-6 sm:px-0">
                <Controller
                  control={control}
                  name="email"
                  rules={{ required: true, pattern: regexForEmailAddress }}
                  render={({ field: { name, value, onChange } }) => {
                    return (
                      <TextField
                        name={name}
                        type="email"
                        placeholder="Email"
                        inputClasses="border border-grey-450"
                        placeholderStyle="text-black font-normal text-base font-ssp"
                        value={value}
                        onChange={(v) => onChange(v)}
                        error={isUserRegistered || isIncorrectPassword}
                        // errorMessage={
                        //   (isUserRegistered !== "" || isIncorrectPassword ) && "Invalid Username"
                        // }
                        // error={errors.email || isUserRegistered}
                        required
                        fullWidth
                      />
                    );
                  }}
                />
              </div>
              <div className="flex flex-col pb-[69px] sm:pb-[42px] w-screen px-6 sm:px-0 sm:w-[300px]">
                <Controller
                  control={control}
                  name="password"
                  rules={{ required: true, pattern: regexForPassword }}
                  render={({ field: { name, value, onChange } }) => {
                    return (
                      <TextField
                        name={name}
                        type="password"
                        placeholder="Password"
                        inputClasses="border border-grey-450"
                        placeholderStyle="text-black font-ssp font-normal text-base"
                        value={value}
                        onChange={(v) => onChange(v)}
                        // error={errors.password || isIncorrectPassword}
                        error={
                          errors.password || isIncorrectPassword || errors.email || isUserRegistered
                        }
                        errorMessage={
                          (!isIncorrectPassword &&
                            getErrorMessage(
                              errors as Record<string, { type: any }>,
                              "password",
                              "Password",
                            )) ||
                          isUserRegistered !== ""
                            ? isUserRegistered
                            : getErrorMessage(errors as Record<string, { type: any }>, "email", "Email")
                        }
                        required
                        fullWidth
                      />
                    );
                  }}
                />
                {signInError && <ErrorField errorMessage={signInError} />}
                <div className="flex justify-end w-full text-sm font-normal sm:text-base pt-7 sm:pt-5 text-primary font-ssp">
                  <span className="cursor-pointer" onClick={() => setIsForgotPassword(true)}>
                    Forgot Password?
                  </span>
                </div>
              </div>
              <div className="pb-4">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY as string}
                  ref={recaptchaRef}
                  onChange={captchaValidate}
                />
              </div>
              <div>
                <Button
                  bgColor="bg-primary-1050"
                  fontStyle={{
                    fontFamily: "font-ssp",
                    fontSize: "text-base",
                    fontWeight: "font-medium",
                    fontColor: "text-white",
                  }}
                  borderStyle={{
                    borderWidth: "border",
                    borderRadius: "rounded",
                  }}
                  className="w-[223px] h-[54px]"
                  isLoading={loading}
                  disabled={(isDisabled && process.env.REACT_APP_ENFORCE_CAPTCHA === "true") || loading}
                >
                  Login
                </Button>
              </div>
              <div className="flex space-x-1 mt-[34px] font-ssp font-normal text-lg z-10">
                <span className="text-black">New to HOP?</span>
                <span
                  className="cursor-pointer text-primary-950"
                  onClick={() => {
                    navigate("/auth/sign-up");
                    Mixpanel.track("Signup_button");
                  }}
                >
                  Sign Up
                </span>
              </div>
            </form>
          </div>
          <div className="flex flex-col items-center p-40">
            {/* <div className="pb-3 text-sm font-normal sm:text-base sm:pb-5 font-ssp text-grey-300">
              Powered by
            </div> */}
            <div>
              {/* <img
                src={"/images/svg/sbm-dark-logo.svg"}
                alt="sbm-dark-logo"
                height="61px"
                width="244px"
                className="mb-6"
              /> */}
            </div>
          </div>
        </>
        // <>
        //     <AuthBgLayout>
        //         <div className="flex flex-col items-start w-full mt-40">
        //             <p className="text-[32px] font-semibold text-[#FFF] mb-4">Log In</p>
        //             <form
        //                 onSubmit={handleSubmit(onSubmit)}
        //                 className="flex flex-col items-start gap-3 w-full"
        //                 autoComplete="off"
        //             >
        //                 <div className="w-full">
        //                     <Controller
        //                         control={control}
        //                         name="email"
        //                         rules={{ required: true, pattern: regexForEmailAddress }}

        //                         render={({ field: { name, value, onChange } }) => {
        //                             return (
        //                                 <>
        //                                     <p className="text-xl font-medium text-[#FFF] mb-2">Email <span className="text-red-100">*</span></p>
        //                                     <TextField
        //                                         name={name}
        //                                         type="email"
        //                                         placeholder="Enter your email"
        //                                         inputClasses=" flex 
        //                                             !h-[55.104px] 
        //                                             px-4  
        //                                             justify-between 
        //                                             items-center 
        //                                             self-stretch 
        //                                             rounded-[12px] 
        //                                             border border-[#D9D9D9]/100 border-[0.5px] 
        //                                             bg-[#f5f5f5]/10
        //                                             !text-[#fff]"
        //                                         placeholderStyle="text-[#D0D5DD] font-normal text-xl font-inter !top-[0.85rem]"
        //                                         value={value}
        //                                         onChange={(v) => onChange(v)}
        //                                         error={isUserRegistered || isIncorrectPassword}
        //                                         // errorMessage={
        //                                         //   (isUserRegistered !== "" || isIncorrectPassword ) && "Invalid Username"
        //                                         // }
        //                                         // error={errors.email || isUserRegistered}
        //                                         // required
        //                                         fullWidth
        //                                     />
        //                                 </>
        //                             );
        //                         }}
        //                     />
        //                 </div>
        //                 <div className="flex flex-col w-full">
        //                     <Controller
        //                         control={control}
        //                         name="password"
        //                         rules={{ required: true, pattern: regexForPassword }}
        //                         render={({ field: { name, value, onChange } }) => {
        //                             return (
        //                                 <>
        //                                     <p className="text-xl font-medium text-[#FFF] mb-2">Password <span className="text-red-100">*</span></p>
        //                                     <TextField
        //                                         name={name}
        //                                         type="password"
        //                                         placeholder="Enter password"
        //                                         inputClasses=" flex 
        //                                             h-[55.104px] 
        //                                             px-4  
        //                                             justify-between 
        //                                             items-center 
        //                                             self-stretch 
        //                                             rounded-[12px] 
        //                                             border border-[#D9D9D9]/100 border-[0.5px] 
        //                                             bg-[#f5f5f5]/10
        //                                             !text-[#fff]"
        //                                         placeholderStyle="text-[#D0D5DD] font-normal text-xl font-inter !top-[0.85rem]"
        //                                         value={value}
        //                                         onChange={(v) => onChange(v)}
        //                                         // error={errors.password || isIncorrectPassword}
        //                                         error={
        //                                             errors.password || isIncorrectPassword || errors.email || isUserRegistered
        //                                         }
        //                                         errorMessage={
        //                                             (!isIncorrectPassword &&
        //                                                 getErrorMessage(
        //                                                     errors as Record<string, { type: any }>,
        //                                                     "password",
        //                                                     "Password",
        //                                                 )) ||
        //                                                 isUserRegistered !== ""
        //                                                 ? isUserRegistered
        //                                                 : getErrorMessage(errors as Record<string, { type: any }>, "email", "Email")
        //                                         }
        //                                         // required
        //                                         fullWidth
        //                                     />
        //                                 </>
        //                             );
        //                         }}
        //                     />
        //                     {signInError && <ErrorField errorMessage={signInError} />}
        //                     <div className="flex justify-end w-full text-sm font-normal sm:text-base  text-primary font-inter mt-2">
        //                         <span className="cursor-pointer" onClick={() => setIsForgotPassword(true)}>
        //                             Forgot Password?
        //                         </span>
        //                     </div>
        //                 </div>
        //                 <div className="w-full">
        //                     <ReCAPTCHA
        //                         sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY as string}
        //                         ref={recaptchaRef}
        //                         onChange={captchaValidate}
        //                         theme="dark"
        //                         size="normal"
        //                     />
        //                 </div>
        //                 <div className="flex flex-col items-center gap-3 w-full">
        //                     <Button
        //                         bgColor={isDisabled ? "bg-gray-300" : "bg-primary-1050"}
        //                         fontStyle={{
        //                             fontFamily: "font-inter",
        //                             fontSize: "text-xl",
        //                             fontWeight: "font-semibold",
        //                             fontColor: "text-white",
        //                         }}
        //                         borderStyle={{
        //                             borderWidth: "border-none",
        //                             borderRadius: "rounded",
        //                         }}
        //                         className="w-full h-[66px] disabled:opacity-50 disabled:cursor-not-allowed"
        //                         isLoading={loading}
        //                         disabled={(isDisabled && process.env.REACT_APP_ENFORCE_CAPTCHA === "true") || loading}
        //                     >
        //                         Login
        //                     </Button>

        //                     <p className="text-white text-xl font-normal">OR</p>

        //                     <Button
        //                         bgColor={isDisabled ? "bg-gray-300" : "bg-primary-1050"}
        //                         fontStyle={{
        //                             fontFamily: "font-inter",
        //                             fontSize: "text-xl",
        //                             fontWeight: "font-semibold",
        //                             fontColor: "text-[#0F5BF1]",
        //                         }}
        //                         borderStyle={{
        //                             borderWidth: "border",
        //                             borderRadius: "rounded",
        //                             borderColor: "border-[#0F5BF1]"
        //                         }}
        //                         isLoading={loading}
        //                         className="w-full h-[66px] disabled:opacity-50 disabled:cursor-not-allowed bg-transparent"
        //                         onClickHandler={() => {
        //                             navigate("/auth/sign-up");
        //                             Mixpanel.track("Signup_button");
        //                         }}
        //                     >
        //                         Sign Up
        //                     </Button>
        //                 </div>
        //             </form>
        //         </div>
        //     </AuthBgLayout>
        // </>
    );
};
